module.exports = __webpack_public_path__ + "img/cards.2161d9a6.png";